<template>
  <div class="prep-page">
    <div class="prep-header">
      <div class="prep-header-left">
        <button class="back-btn" @click="$router.push('/')">
          <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
          </svg>
        </button>
        <h2 class="prep-title">智能备课系统</h2>
      </div>
      <!-- <CoinBalance /> -->
    </div>
    
    <div class="header">
      <div class="subtitle">建筑钢结构工程技术专业</div>
      <h1 class="main-title">一键备课系统</h1>
    </div>
    
    <div class="content-wrapper">
      <CategoryTabs @category-change="handleCategoryChange" />
      
      <!-- 资源展示区域 -->
      <div class="resources-container">
        <div class="section-header">
          <h2 class="section-title">备课资源</h2>
          <!-- <div class="section-desc">点击下载开始生成对应资源</div> -->
        </div>
        
        <ResourceGrid 
          :resources="resources"
          :status="resourceStatus"
          @download="handleResourceGenerate"
        />
      </div>
    </div>
    
    <div 
      class="floating-download" 
      :class="{ show: hasGeneratedResources }"
      @click="downloadAll"
    >
      📦
    </div>
  </div>
</template>

<script>
import CoinBalance from '@/components/common/CoinBalance.vue'
import CategoryTabs from '@/components/prep/CategoryTabs.vue'
import ResourceGrid from '@/components/prep/ResourceGrid.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'PrepLesson',
  
  components: {
    CoinBalance,
    CategoryTabs,
    ResourceGrid
  },
  
  data() {
    return {
      selectedCategory: 'basic',
      resources: [
        { id: 'ppt', name: 'PPT课件', icon: '📊', color: '#ffeaa7' },
        { id: 'standard', name: '课程标准', icon: '📋', color: '#a29bfe' },
        { id: 'design', name: '单元设计', icon: '📝', color: '#55efc4' },
        { id: 'schedule', name: '进度表', icon: '📅', color: '#fdcb6e' },
        { id: 'assessment', name: '考核方案', icon: '📑', color: '#ff7675' },
        { id: 'exam', name: '试卷模板', icon: '📄', color: '#74b9ff' },
        { id: 'video', name: '教学微课', icon: '🎥', color: '#fd79a8' }
      ],
      resourceStatus: {}
    }
  },
  
  computed: {
    ...mapGetters(['userCoins']),
    
    hasGeneratedResources() {
      return Object.values(this.resourceStatus).some(status => status === 'complete')
    }
  },
  
  mounted() {
    // 初始化所有资源为可点击状态
    this.resources.forEach(resource => {
      this.$set(this.resourceStatus, resource.id, 'ready')
    })
  },
  
  methods: {
    ...mapActions(['consumeCoins', 'showToast']),
    
    handleCategoryChange(category) {
      this.selectedCategory = category
    },
    
    async handleResourceGenerate(resourceId) {
      const resource = this.resources.find(r => r.id === resourceId)
      
      // 如果已经生成完成，直接下载
      if (this.resourceStatus[resourceId] === 'complete') {
        await this.downloadResource(resourceId)
        return
      }
      
      // 开始生成
      this.$set(this.resourceStatus, resourceId, 'generating')
      this.showToast(`正在生成 ${resource.name}...`)
      
      // 模拟生成过程
      setTimeout(() => {
        this.$set(this.resourceStatus, resourceId, 'complete')
        this.showToast(`${resource.name} 生成完成！`)
      }, 2000 + Math.random() * 2000)
    },
    
    async downloadResource(resourceId) {
      const resource = this.resources.find(r => r.id === resourceId)
      const cost = 500
      
      if (this.userCoins < cost) {
        this.showToast('FF币不足！请通过分享或邀请获取更多FF币')
        setTimeout(() => {
          this.$router.push('/recharge')
        }, 1500)
        return
      }
      
      if (confirm(`下载 ${resource.name} 将消耗 ${cost} FF币，确认下载？`)) {
        const success = await this.consumeCoins(cost)
        if (success) {
          this.showToast(`正在下载 ${resource.name}...`)
          // 实际下载逻辑
        }
      }
    },
    
    async downloadAll() {
      const completedResources = this.resources.filter(r => 
        this.resourceStatus[r.id] === 'complete'
      )
      const totalCost = completedResources.length * 500
      
      if (completedResources.length === 0) {
        this.showToast('请先生成资源')
        return
      }
      
      if (this.userCoins < totalCost) {
        this.showToast('FF币不足！请通过分享或邀请获取更多FF币')
        setTimeout(() => {
          this.$router.push('/recharge')
        }, 1500)
        return
      }
      
      if (confirm(`打包下载 ${completedResources.length} 个资源将消耗 ${totalCost} FF币，确认下载？`)) {
        const success = await this.consumeCoins(totalCost)
        if (success) {
          this.showToast('正在打包下载所有资源...')
          // 实际打包下载逻辑
        }
      }
    }
  }
}
</script>

<style scoped>
.prep-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #F5F5F7 0%, #E8F3FF 100%);
}

.prep-header {
  background: var(--bg-glass);
  backdrop-filter: blur(var(--blur-lg));
  border-bottom: 1px solid var(--border-light);
  position: sticky;
  top: 0;
  z-index: 100;
  padding: 20px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.prep-header-left {
  display: flex;
  align-items: center;
  gap: 20px;
}

.back-btn {
  width: 44px;
  height: 44px;
  background: rgba(255, 255, 255, 0.5);
  border: 1px solid var(--border-light);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
  color: var(--text-dark);
}

.back-btn:hover {
  background: rgba(255, 255, 255, 0.8);
  transform: scale(1.05);
}

.prep-title {
  font-size: 24px;
  font-weight: 600;
  color: var(--text-dark);
}

.header {
  padding: 20px 20px 40px;
  text-align: center;
}

.subtitle {
  font-size: 18px;
  color: var(--text-light);
  margin-bottom: 12px;
  font-weight: 500;
}

.main-title {
  font-size: 36px;
  font-weight: 700;
  color: var(--text-dark);
  margin-bottom: 8px;
}

.content-wrapper {
  padding: 0 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.resources-container {
  margin-top: 40px;
}

.section-header {
  text-align: center;
  margin-bottom: 40px;
}

.section-title {
  font-size: 28px;
  font-weight: 600;
  color: var(--text-dark);
  margin-bottom: 8px;
}

.section-desc {
  font-size: 16px;
  color: var(--text-light);
}

.floating-download {
  position: fixed;
  bottom: 100px;
  right: 32px;
  width: 72px;
  height: 72px;
  background: linear-gradient(135deg, #27ae60, #2ecc71);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 32px;
  box-shadow: 0 8px 32px rgba(46, 204, 113, 0.3);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  opacity: 0;
  transform: scale(0);
}

.floating-download.show {
  opacity: 1;
  transform: scale(1);
}

.floating-download:hover {
  transform: scale(1.1);
  box-shadow: 0 12px 40px rgba(46, 204, 113, 0.4);
}
</style>